import { getter } from 'ember-cli-page-object/macros';
import { findOne } from 'ember-cli-page-object/extend';
export function isChecked(selector) {
  return getter(function (pageObjectKey) {
    return findOne(this, selector, {
      pageObjectKey
    }).checked;
  });
}